<template>
  <div class="rdmanagement-project-pc">
    <a-tabs type="card" v-model:activeKey="activeKey" @change="handleTabChange">
      <a-tab-pane :disabled="linkLock" key="项目计划" tab="项目计划">
        <project-scheme></project-scheme>
      </a-tab-pane>
      <a-tab-pane :disabled="linkLock" key="问题进度" tab="问题进度">
        <requirement type="问题"></requirement>
      </a-tab-pane>

      <a-tab-pane :disabled="linkLock" key="需求进度" tab="需求进度">
        <requirement type="需求"></requirement>
      </a-tab-pane>
      <a-tab-pane :disabled="linkLock" key="资料库" tab="资料库">
        <a-tabs type="card" v-model:activeKey="dataBaseKey" v-if="!isEchoDataBase" @change="handleTabChange">
          <template v-for="(item, index) in libTypeOptions" :key="item.value">
            <a-tab-pane :disabled="linkLock" :tab="item.label">
              <data-base :libType="item.value"></data-base>
            </a-tab-pane>
          </template>
        </a-tabs>
        <echo-data-base v-else></echo-data-base>
      </a-tab-pane>

      <a-tab-pane :disabled="linkLock" key="设计变更" tab="设计变更">
        <ena></ena>
      </a-tab-pane>

      <a-tab-pane :disabled="linkLock" key="BOM表" tab="BOM表">
        <a-tabs type="card" v-model:activeKey="dataBaseKey" @change="handleTabChange">
          <template v-for="(item, index) in bomAuthorityList" :key="item.value">
            <a-tab-pane :disabled="linkLock" :tab="item.label">
              <all-bom :bomType="item.value" :requestType="item.type"></all-bom>
            </a-tab-pane>
          </template>
        </a-tabs>
      </a-tab-pane>
    </a-tabs>

    <div>
      <notice-bell class="bell-location" v-if="!linkLock"></notice-bell>
      <back-vue class="back-location"></back-vue>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, provide, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import {
  libTypeOptions,
  bomOptions,
} from "@/views/rdmanagement/components/database/options";

import { RNDdepartment } from "@/views/rdmanagement/serve/constant";
import { getBomAuthorityByProjectId } from "@/views/rdmanagement/serve/authority";
import echoDataBase from "@/views/rdmanagement/components/database/index.vue";
import backVue from "@/components/back/index.vue";
import dataBase from "@/views/rdmanagement/components/database/lib.vue";
import requirement from "@/views/rdmanagement/components/demand/aRequirement.vue";
import projectScheme from "@/views/rdmanagement/components/projectScheme/aTable.vue";
import ena from "@/views/rdmanagement/components/ena/index.vue";
import noticeBell from "@/layout/components/noticeBell.vue";
import allBom from "@/views/rdmanagement/components/bom/all/index.vue";
import optionsBom from "@/views/rdmanagement/components/bom/options/index.vue";

export default defineComponent({
  components: {
    dataBase,
    backVue,
    requirement,
    projectScheme,
    ena,
    echoDataBase,
    noticeBell,
    allBom,
    optionsBom,
  },
  setup() {
    const route = useRoute();
    const { secondaryDepartment, id } = useStore().state.user.user;
    const dataBaseConfig = reactive({
      isNotice: false,
      type: null,
    });
    const isEchoDataBase = ref(false);
    const showDataBase = computed(() => (type) => {
      if (!dataBaseConfig.type) {
        return true;
      }
      return dataBaseConfig.type === type;
    });

    provide("dataBaseConfig", dataBaseConfig);

    const activeKey = ref("项目计划");

    provide("activeKey", activeKey);

    const dataBaseKey = ref("DD");

    provide("dataBaseKey", dataBaseKey);

    const linkLock = ref(false);

    const handleTabChange = () => {
      localStorage.setItem(
        "rdManagmentTab",
        JSON.stringify({
          active: activeKey.value,
          dataBase: dataBaseKey.value,
        })
      );
    };

    const cacheTab = localStorage.getItem("rdManagmentTab");

    // BOM表的权限判断
    const isElectron = RNDdepartment.electronicGroup === secondaryDepartment;
    const isOptics = RNDdepartment.opticalGroup === secondaryDepartment;
    const isStructure = RNDdepartment.structureGroup === secondaryDepartment;
    const isAllBomAuthority = ref(false);

    const bomAuthority = {
      // 电子组
      electronbom: computed(() => isElectron || route.query.userId == id),
      // 光学组
      opticsbom: computed(() => isOptics || route.query.userId == id),
      // 结构组
      structurebom: computed(() => isStructure || route.query.userId == id),
      // 项目负责人
      allbom: computed(
        () => route.query.userId == id || isAllBomAuthority.value
      ),
      // 辅料BOM
      accessoriesbom: computed(
        () => isElectron || isOptics || isStructure || route.query.userId == id
      ),
    };

    const bomAuthorityList = reactive([]);

    // BOM表权限设置
    const setBomOptions = () => {
      bomAuthorityList.length = 0;
      bomOptions.forEach((item) => {
        if (bomAuthority[item.value].value) {
          bomAuthorityList.push(item);
        }
      });
    };

    const updateBomAuthority = () => {
      isAllBomAuthority.value = getBomAuthorityByProjectId(
        route.query.projectId
      );
      setBomOptions();
    };

    watch(
      () => route.path,
      (val, oldval) => {
        updateBomAuthority();

        if (route.query.type === 'materialLinkBom') {
          activeKey.value = "BOM表";
          dataBaseKey.value = route.query.subActiveKey;
          return;
        }

        if (val === "/notice" || oldval === "/notice") {
          if (route.query.type === "link") {
            isEchoDataBase.value = true;
            activeKey.value = route.query.activeKey;
            dataBaseKey.value = null;
            linkLock.value = true;
          } else {
            isEchoDataBase.value = false;
            linkLock.value = false;
          }
          return;
        }
        dataBaseConfig.isNotice = route.query.type === "link";
        dataBaseConfig.type = route.query.dataLibType;

        if (route.query.type === "link") {
          isEchoDataBase.value = true;
          activeKey.value = route.query.activeKey;
          dataBaseKey.value = null;
          linkLock.value = true;
          return;
        } else {
          isEchoDataBase.value = false;
          linkLock.value = false;
        }

        if (route.path === "/rdprojectlayout" && route.query.type !== "link") {
          activeKey.value = "项目计划";
          dataBaseKey.value = "DD";
        }

        if (oldval === undefined && cacheTab) {
          const { active, dataBase } = JSON.parse(cacheTab);
          activeKey.value = active;
          dataBaseKey.value = dataBase;
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      linkLock,
      bomAuthorityList,
      handleTabChange,
      isEchoDataBase,
      libTypeOptions,
      bomOptions,
      showDataBase,
      dataBaseConfig,
      activeKey,
      dataBaseKey,
    };
  },
});
</script>
<style lang="less" scoped>
.rdmanagement-project-pc {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: 20px;
  width: 100vw;
  height: 100vh;
}

.bell-location {
  position: fixed;
  right: 60px;
  top: 28px;
}

.back-location {
  position: fixed;
  right: 20px;
  top: 20px;
}
</style>
